import React from 'react'

function PurchaseInvoiceStatistics() {
  return (
    <div>PurchaseInvoiceStatistics</div>
  )
}

export default PurchaseInvoiceStatistics